import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';

export type TextFieldTint = 'info' | 'success' | 'warning' | 'none';

export const TintedTextField = styled(TextField, {
  shouldForwardProp: prop => prop !== 'tint',
})<{ tint: TextFieldTint }>(({ theme, tint }) => {
  // An existing record reads in brand color on the pale info fill, not info text.
  const tints = {
    info: { fill: theme.palette.info.lighter, text: theme.palette.primary.main },
    success: { fill: theme.palette.success.lighter, text: theme.palette.success.main },
    warning: { fill: theme.palette.warning.lighter, text: theme.palette.warning.main },
    none: { fill: 'transparent', text: theme.palette.text.secondary },
  };

  return {
    backgroundColor: tints[tint].fill,
    '& .MuiInputBase-input': {
      color: tints[tint].text,
    },
  };
});
